import { APITransport } from '@client/transports/api';

export const BizCardsRoutingService = {
  deleteRoute(body) {
    return APITransport.post({
      path: '/rest/domain/delete/bizcardroutes',
      body
    });
  },
  findByEmail(body) {
    return APITransport.post({
      path: '/rest/domain/execute/findbizcards',
      body
    });
  },
  getAll() {
    return APITransport.get({
      path: '/rest/domain/bizcardroutes'
    });
  },
  saveRouteOrder(orderedArray) {
    return APITransport.post({
      path: '/rest/domain/execute/reorderbizcardroutes',
      body: {
        orderedArray
      }
    });
  },
  updateRoute(body) {
    return APITransport.post({
      path: '/rest/domain/save/bizcardroutes',
      body
    });
  },
  async disableRoutesByBizcard(blockname) {
    const routes = await this.getAll();
    if (!Array.isArray(routes)) return routes;

    const matches = routes.filter((r) => r.blockname === blockname && r.status);
    const results = [];
    for (const route of matches) {
      results.push(await this.updateRoute({ ...route, status: false }));
    }
    return results;
  },
  async deleteRoutesByBizcard(blockname) {
    const routes = await this.getAll();
    if (!Array.isArray(routes)) return routes;

    const matches = routes.filter((r) => r.blockname === blockname);
    const results = [];
    for (const route of matches) {
      results.push(await this.deleteRoute(route));
    }
    return results;
  }
};
